class MFRHeader {

    constructor( index, element ) {
        this.$element = $( element );
    
    
        this.selectors = {
          menuItem: ".header-menu__item"
        }
    
        this.states = {
          header: {
            MEGA_OPEN: "header--mega-open",
            IS_STICKY: "header--is-sticky"
          },
    
          menuItem: {
            HAS_MEGA: "header-menu__item--has-mega-menu"
          }
        };
    
    
        this.initialize();
    }

    initialize() {
        this.$menuItems = this.$element.find( this.selectors.menuItem );

        this.$menuItems
        .on( "mouseenter", this._handleMenuItemMouseEnter.bind( this ) )
        .on( "mouseleave", this._handleMenuItemMouseLeave.bind( this ) );

        $( window ).on( "load scroll resize", this.setStickyHeader.bind( this ) );
    }

    setStickyHeader() {
        const top = $( window ).scrollTop();

        this.$element.toggleClass( this.states.header.IS_STICKY, top > 0 );
    }

    _handleMenuItemMouseEnter( event ) {
        const $target = $( event.target );
        const $menuItem = $target.closest( this.selectors.menuItem );

        if( $menuItem.hasClass( this.states.menuItem.HAS_MEGA ) )
        this.$element.addClass( this.states.header.MEGA_OPEN );
    }

    _handleMenuItemMouseLeave( event ) {
        this.$element.removeClass( this.states.header.MEGA_OPEN );
    }
}